<template>
  <ul class="menu">
    <li class="menu-list" v-for="(list,index) in menuList" :key="index" @click="tabChange(list,index)">
      <img v-if="currentIndex===index" class="menu-icon" :src="list.activeIcon" alt="active">
      <img v-else class="menu-icon" :src="list.icon" alt="icon" />
      <span :class="{'menu-title':true,'active':currentIndex===index}">{{list.name}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LayoutMyMenu',
  data() {
    return {
      currentIndex: 0,
      menuList: [
        // {
        //   name: '基本信息',
        //   path: '/info',
        //   icon: require('@/assets/image/plan.png'),
        //   activeIcon: require('@/assets/image/planActive.png')
        // },
        // {
        //   name: '身份信息',
        //   path: '/identity',
        //   icon: require('@/assets/image/course.png'),
        //   activeIcon: require('@/assets/image/courseActive.png')
        // },
        // {
        //   name: '收货地址',
        //   path: '/address',
        //   icon: require('@/assets/image/order.png'),
        //   activeIcon: require('@/assets/image/orderActive.png'),
        // },
        {
          name: '账号设置',
          path: '/account',
          icon: require('@/assets/image/lock.png'),
          activeIcon: require('@/assets/image/lockActive.png'),
        }
      ]
    }
  },
  methods: {
    // 菜单切换
    tabChange(list, index) {
      this.currentIndex = index
      this.$router.push('/my' + list.path)
    },
  }
}
</script>

<style lang="scss" scoped>
.menu {
  margin: 30px 0 52px 93px;
  .menu-list {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 22px 0;
    .menu-icon {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    .menu-title {
      &.active {
        color: $theme-color;
      }
    }
  }
}
</style>